import api from './api';

export const surveyService = {
  getAll: (params) => api.get('/surveys', { params }),
  getById: (id) => api.get(`/surveys/${id}`),
  create: (data) => api.post('/surveys', data),
  dispatch: (id, dp_ids) => api.post(`/surveys/${id}/dispatch`, { dp_ids }),
  getStats: () => api.get('/surveys/stats'),
};

export const establishmentService = {
  getAll: (params) => api.get('/establishments', { params }),
  getById: (id) => api.get(`/establishments/${id}`),
  create: (data) => api.post('/establishments', data),
  update: (id, data) => api.put(`/establishments/${id}`, data),
};

export const providerService = {
  getAll: (params) => api.get('/providers', { params }),
  create: (data) => api.post('/providers', data),
  update: (id, data) => api.put(`/providers/${id}`, data),
  updateStatus: (id, status) => api.patch(`/providers/${id}/status`, { status }),
};

export const referenceService = {
  getYears:                 ()       => api.get('/years'),
  getQuarters:              (year_id)  => api.get('/quarters', { params: { year_id } }),
  getMonths:                (quarter_id) => api.get('/months', { params: { quarter_id } }),
  getExpenditureItems:      (type)   => api.get('/expenditure-items', { params: type ? { type } : {} }),
  getAllExpenditureItems:    ()       => api.get('/expenditure-items/all'),
  createExpenditureItem:    (data)   => api.post('/expenditure-items', data),
  updateExpenditureItem:    (id, data) => api.put(`/expenditure-items/${id}`, data),
  toggleExpenditureItem:    (id)     => api.patch(`/expenditure-items/${id}/toggle`),
  getUnits:                 ()       => api.get('/units'),
  getAllUnits:              ()       => api.get('/units/all'),
  createUnit:               (data)   => api.post('/units', data),
  updateUnit:               (id, data) => api.put(`/units/${id}`, data),
  toggleUnit:               (id)     => api.patch(`/units/${id}/toggle`),
};